import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;
export type UserContentStylesProps = {
	spacing: number;
};

export const useStyles = makeStyles(theme => {
	return {
		showroomGridRowDisplayContainer: {
			display: 'flex',
			flexFlow: 'wrap',
			margin: (props: UserContentStylesProps) => `0 calc(${props.spacing}% * -1)`
		},
		showroomGridRow: {
			display: 'flex',
			flexWrap: 'wrap'
		},
		showroomGridItem: {
			display: 'flex',
			flexDirection: 'column',
			position: 'relative',
			margin: (props: UserContentStylesProps) => `${props.spacing}%`,
			[theme.breakpoints.up('sm')]: {
				minWidth: `0 !important`
			}
		},
		showroomGridItemContent: {
			flexGrow: 1
		},
		showroomGridItemLabel: {
			overflow: 'hidden',
			height: 18,
			color: '#FFF'
		}
	};
});
